import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { dialogFormColumn } from '../../../theme/mixins';

export const dialogTitleStyles: SxProps<Theme> = {
    fontWeight: 700,
    letterSpacing: '-0.015em',
};

/** Lets the fields scroll under a pinned footer -- see `dialogFormColumn`. */
export const dialogFormStyles: SxProps<Theme> = dialogFormColumn;

export const formAlertStyles: SxProps<Theme> = {
    mb: 2,
    borderRadius: 3,
};

export const fieldsBoxStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    pt: 1,
};

export const dialogActionsStyles: SxProps<Theme> = {
    px: 3,
    pb: 3,
    pt: 1,
    gap: 1,
};
